// Packages
import PropTypes from 'prop-types'

// Components
import TestEquipmentForm from 'modules/TestEquipment/components/Form';

// Other
import useApi from 'hooks/useApi';

const TestEquipmentEditScreen = ({  itemId, onClose, onSubmit }) => {

    const { data: item, put: updateItem, errors } = useApi('/testequipment/' + itemId);

	const submit = async (values) => {

        if( await updateItem(values, 'Test Equipment updated!')) {

            onSubmit();
        }
    }

    return(
        <TestEquipmentForm 
            errors={errors} 
            testEquipment={item} 
            onClose={onClose} 
            onSubmit={submit} 
            type='edit' 
        />
    )
}

TestEquipmentEditScreen.propTypes = {
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func,
    onSubmit: PropTypes.func,
}

TestEquipmentEditScreen.defaultProps = {
    itemId: null,
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')}
}

export default TestEquipmentEditScreen;